import { getLenis } from '@/lib/lenis'

export default {
	menuOpen: false,
	mobileSearchOpen: false,
	showAnnouncement: true,
	filtersOpen: false,
	activeFilterCount: 0,

	init() {
		this.menuEl = document.querySelector('[data-mobile-menu]')
		this.menuToggle = document.querySelector('[data-menu-toggle]')

		this.filtersEl = document.querySelector('.collection-filters')

		this.handleMenuOutsideClick = this.handleMenuOutsideClick.bind(this)
		this.handleFiltersOutsideClick = this.handleFiltersOutsideClick.bind(this)
		this.handleKeyUp = this.handleKeyUp.bind(this)

		window.addEventListener('keyup', this.handleKeyUp)
	},

	handleKeyUp(e) {
		if (e.key === 'Escape') {
			this.closeMenu()
			this.closeFilters()
			this.closeMobileSearch()
		}
	},

	openMenu() {
		if (this.mobileSearchOpen) this.closeMobileSearch()
		this.menuOpen = true

		// Trigger mobile menu open animation
		window.dispatchEvent(new CustomEvent('mobile-menu:open'))

		requestAnimationFrame(() => {
			this.setupMenuListeners()
		})
	},

	closeMenu() {
		if (!this.menuOpen) return
		this.menuOpen = false

		// Trigger mobile menu close animation
		window.dispatchEvent(new CustomEvent('mobile-menu:close'))

		requestAnimationFrame(() => {
			this.removeMenuListeners()
		})
	},

	toggleMenu() {
		this.menuOpen ? this.closeMenu() : this.openMenu()
	},

	handleMenuOutsideClick(event) {
		if (!this.menuEl.contains(event.target)) {
			this.closeMenu()
		}
	},

	handleFiltersOutsideClick(event) {
		if (!this.filtersEl.contains(event.target)) {
			this.closeFilters()
		}
	},

	setupMenuListeners() {
		window.addEventListener('click', this.handleMenuOutsideClick)
	},

	removeMenuListeners() {
		window.removeEventListener('click', this.handleMenuOutsideClick)
	},

	get isMenuOpen() {
		return this.menuOpen
	},

	openMobileSearch() {
		if (this.menuOpen) this.closeMenu()
		this.mobileSearchOpen = true
		getLenis()?.stop()
	},

	closeMobileSearch() {
		this.mobileSearchOpen = false
		getLenis()?.start()
	},

	toggleMobileSearch() {
		this.mobileSearchOpen ? this.closeMobileSearch() : this.openMobileSearch()
	},

	get isMobileSearchOpen() {
		return this.mobileSearchOpen
	},

	dismissAnnouncement() {
		this.showAnnouncement = false
	},

	get isAnnouncementVisible() {
		return this.showAnnouncement
	},

	toggleFilters() {
		this.filtersOpen = !this.filtersOpen

		if (this.filtersOpen) {
			this.openFilters()
		} else {
			this.closeFilters()
		}
	},

	openFilters() {
		if (this.menuOpen) {
			this.closeMenu()
		}

		this.filtersOpen = true
		getLenis()?.stop()

		requestAnimationFrame(() => {
			this.setupFiltersListeners()
		})
	},

	closeFilters() {
		this.filtersOpen = false
		getLenis()?.start()

		requestAnimationFrame(() => {
			this.removeFiltersListeners()
		})
	},

	get isFiltersOpen() {
		return this.filtersOpen
	},
}
